<section class="stacksBlockContainer" id="block-slider">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>
  <!-- Sidebar -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="appendBlock($event)">
    <img src="assets/icons/slider.svg" alt="" />
    <p>{{ 'Slider' | translate }}</p>
  </div>
  <!-- Mobile Preview -->
  <div class="previewSlider previewMobile" *ngIf="checkPreview()" id="{{ 'blockid' + blockId }}" cdkDrag [cdkDragData]="blockId">
    <div class="blockControlHandlers" *ngIf="!builderService.globals">
      <div class="editBlock blockActionBtn" (click)="showData(blockId); $event.stopPropagation()">
        <mat-icon>edit</mat-icon>
      </div>
      <div class="blockHandle blockActionBtn" cdkDragHandle>
        <mat-icon>open_with</mat-icon>
      </div>
      <div class="deleteBlock blockActionBtn" (click)="deleteBlock(blockId); $event.stopPropagation()">
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <div class="blockPlaceholder" *cdkDragPlaceholder></div>

    <!-- Mobile Builder Carousel -->
    <carousel *ngIf="builderType === 'mobile'" [ngStyle]="getBlockFields(blockId)?.style" [cellsToShow]="1" [autoplay]="true" [arrows]="true" [dots]="false" [autoplayInterval]="3000" [loop]="true">
      <div class="carousel-cell" *ngFor="let slide of getBlockFields(blockId).data?.slides">
        <img src="{{ slide.img }}" />
      </div>
      <div class="carousel-cell" *ngFor="let slide of getBlockFields(blockId).data?.slides">
        <img src="{{ slide.img }}" />
      </div>
    </carousel>

    <!-- Website Builder Bootstrap Carousel -->
    <div *ngIf="builderType === 'website'" [id]="'heroCarousel' + blockId" class="carousel slide" [ngStyle]="getBlockFields(blockId)?.style" data-bs-ride="carousel">
      <div class="carousel-indicators">
        <button *ngFor="let slide of getBlockFields(blockId).data?.slides; let i = index"
                type="button"
                [attr.data-bs-target]="'#heroCarousel' + blockId"
                [attr.data-bs-slide-to]="i"
                [class.active]="i === 0"
                [attr.aria-current]="i === 0 ? 'true' : null"
                [attr.aria-label]="'Slide ' + (i + 1)">
        </button>
      </div>

      <div class="carousel-inner">
        <div *ngFor="let slide of getBlockFields(blockId).data?.slides; let i = index"
             class="carousel-item"
             [class.active]="i === 0">
          <img [src]="slide.img" class="d-block w-100 carousel-image" [alt]="slide.title || 'Slide ' + (i + 1)" loading="lazy">
          <div class="carousel-caption d-none d-md-block text-start" *ngIf="slide.headline || slide.subheading || slide.cta">
            <div class="carousel-content">
              <h1 class="carousel-headline" *ngIf="slide.headline">{{ slide.headline }}</h1>
              <p class="carousel-subheading" *ngIf="slide.subheading">{{ slide.subheading }}</p>
              <button class="btn btn-light btn-lg carousel-cta" *ngIf="slide.cta">{{ slide.cta }}</button>
            </div>
          </div>
        </div>
      </div>

      <button class="carousel-control-prev" type="button" [attr.data-bs-target]="'#heroCarousel' + blockId" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">{{ 'Previous' | translate }}</span>
      </button>
      <button class="carousel-control-next" type="button" [attr.data-bs-target]="'#heroCarousel' + blockId" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">{{ 'Next' | translate }}</span>
      </button>
    </div>
  </div>
  <!-- Data and Style Tabs -->
  <div class="previewFields" *ngIf="checkData()">
    <mat-progress-bar mode="indeterminate" *ngIf="showProgress"></mat-progress-bar>
    <ul>
      <li class="ulWrapper" *ngFor="let slides of getBlockFields(blockId).data.slides; let indexOfelement = index">
        <button *ngIf="indexOfelement !== 0" class="deleteslides material-icons-outlined" (click)="deleteslides(blockId, indexOfelement)">delete</button>
        <mat-accordion multi>
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title> {{ 'Slide' | translate }} {{ indexOfelement + 1 }} </mat-panel-title>
            </mat-expansion-panel-header>
            <label class="fileUpload" for="image{{ indexOfelement }}"
              >{{ 'Choose an Image' | translate }}
              <input type="file" id="image{{ indexOfelement }}" (change)="this.processFile($event, '', indexOfelement, 'img', blockId)" />
            </label>
            <p class="note">{{ getBlockFields(blockId).data.slides[indexOfelement].img }}</p>

            <!-- Website Builder Content Fields -->
            <div *ngIf="builderType === 'website'" class="websiteSlideFields">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Headline' | translate }}</mat-label>
                <input matInput [placeholder]="'Enter slide headline' | translate"
                  value="{{ getBlockFields(blockId).data?.slides[slides.index]?.headline }}"
                  (keyup)="queryChange('headline', blockId, $event, 'multilevelText', slides.index, 'slides')" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'Subheading' | translate }}</mat-label>
                <input matInput [placeholder]="'Enter slide subheading' | translate"
                  value="{{ getBlockFields(blockId).data?.slides[slides.index]?.subheading }}"
                  (keyup)="queryChange('subheading', blockId, $event, 'multilevelText', slides.index, 'slides')" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'CTA Button Text' | translate }}</mat-label>
                <input matInput [placeholder]="'Enter button text' | translate"
                  value="{{ getBlockFields(blockId).data?.slides[slides.index]?.cta }}"
                  (keyup)="queryChange('cta', blockId, $event, 'multilevelText', slides.index, 'slides')" />
              </mat-form-field>
            </div>

            <ul class="dropDownMenu">
              <div class="slidesData" [ngClass]="slides.index == 0 ? 'firstslidesData' : ''">
                <ul class="menuLinker">
                  <li>
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Link Type' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('link', blockId, $event, 'multilevelSelect', slides.index, 'slides')" value="{{ getBlockFields(blockId).data?.slides[slides.index]?.link }}">
                        <mat-option value="home">
                          {{ 'Home' | translate }}
                        </mat-option>
                        <mat-option value="posts" *ngIf="!builderService.standalone">
                          {{ 'WP Posts' | translate }}
                        </mat-option>
                        <mat-option value="products">
                          {{ 'Products' | translate }}
                        </mat-option>
                        <mat-option value="allProductsCategories">
                          {{ 'All Products Categories' | translate }}
                        </mat-option>
                        <mat-option value="productsCategories">
                          {{ 'Product Category' | translate }}
                        </mat-option>
                        <mat-option value="productsSubCategories">
                          {{ 'Product Sub Category' | translate }}
                        </mat-option>
                        <mat-option value="vendorProduct" *ngIf="this.vendor.vendorsList.length > 0">
                          {{'Vendor Products' | translate}}
                        </mat-option>
                        <mat-option value="vendorCat" *ngIf="this.vendor.vendorsList.length > 0">
                          {{'Vendor Categories' | translate}}
                        </mat-option>
                        <!-- <mat-option value="stacksProducts" *ngIf="builderService.standalone">
                              {{ 'Products' | translate }}
                            </mat-option>
                            <mat-option value="stacksCategories" *ngIf="builderService.standalone">
                              {{ 'Categories' | translate }}
                            </mat-option> -->
                        <mat-option value="externalURL">
                          {{ 'External URL' | translate }}
                        </mat-option>
                        <mat-option value="account">
                          {{ 'Account Page' | translate }}
                        </mat-option>
                        <mat-option value="signup">
                          {{ 'Signup / Signin' | translate }}
                        </mat-option>
                        <mat-option value="contact">
                          {{ 'Contact Us' | translate }}
                        </mat-option>
                        <mat-option value="about">
                          {{ 'About Us' | translate }}
                        </mat-option>
                        <mat-option value="orders">
                          {{ 'Orders' | translate }}
                        </mat-option>
                        <mat-option value="cart">
                          {{ 'Cart' | translate }}
                        </mat-option>
                        <mat-option value="terms">
                          {{ 'Terms' | translate }}
                        </mat-option>
                        <mat-option *ngFor="let customView of builderService.getCustomViews()" value="{{ customView.view_name }}">
                          {{ customView.view_name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'products' && !builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Woo-Product' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('product', blockId, $event, 'multilevelSelect', slides.index, 'slides')" [(value)]="getBlockFields(blockId).data.slides[slides.index].product">
                        <mat-option *ngFor="let product of storedProducts" [value]="product.id">
                          {{ product.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'productsCategories' && !builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Woo Product Category' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'multilevelSelect', slides.index, 'slides')" [(value)]="getBlockFields(blockId).data?.slides[slides.index].categories">
                        <mat-option *ngFor="let productCategory of categoriesService.storedCategories" [value]="productCategory.id">
                          {{ productCategory.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'products' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Standalone Product' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('product', blockId, $event, 'multilevelSelect', slides.index, 'menuItems')" [(value)]="getBlockFields(blockId).data.slides[slides.index].product">
                        <mat-option *ngFor="let product of standaloneProductsService.storedStandaloneProducts" [value]="product.Id || product.product_id">
                          {{ product.productName }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'productsCategories' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Product Category' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'multilevelSelect', slides.index, 'menuItems')" [(value)]="getBlockFields(blockId).data?.slides[slides.index].categories">
                        <mat-option *ngFor="let productCategory of standaloneCategoriesService.storedStandaloneCategories" [value]="productCategory.id">
                          {{ productCategory.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'productsCategories' || (getBlockFields(blockId).data?.slides[slides.index]?.link == 'productsSubCategories' && builderService.standalone)">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Product Category' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('categories', blockId, $event, 'select', slides.index, 'menuItems'); getCat($event)" [(value)]="getBlockFields(blockId).data?.slides[slides.index].categories">
                        <mat-option *ngFor="let productCategory of standaloneCategoriesService.storedStandaloneCategories" [value]="productCategory.id">
                          {{ productCategory.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'productsSubCategories' && builderService.standalone && this.standaloneCategoriesService.availableSubs?.length > 0">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Product Sub Category' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('subcategories', blockId, $event, 'select', slides.index, 'menuItems')" [(value)]="getBlockFields(blockId).data?.slides[slides.index].subcategories">
                        <mat-option *ngFor="let subCat of this.standaloneCategoriesService.availableSubs" [value]="subCat.subCategoryId">
                          {{ subCat.subcategory }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>

                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'vendorProduct' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Vendor Projects' | translate }}</mat-label>
                      <mat-select (selectionChange)="getVendorProds($event.value)"
                        [(value)]="getBlockFields(blockId).data.vendorProject">
                        <mat-option *ngFor="let vendorProject of this.vendor.vendorsList" [value]="vendorProject.id">
                          {{ vendorProject.id }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>


                  <li *ngIf="getBlockFields(blockId).data.vendorProject && getBlockFields(blockId).data?.slides[slides.index]?.link == 'vendorProduct' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label> {{ getBlockFields(blockId).data.vendorProject }} {{ 'Products' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('vendorProduct', blockId, $event, 'select', slides.index, 'menuItems')"
                        [(value)]="getBlockFields(blockId).data.vendorProduct">
                        <mat-option *ngFor="let vendorProduct of this.standaloneProductsService.storedVendorProducts" [value]="vendorProduct.id">
                          {{ vendorProduct.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'vendorCat' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'Vendor Projects' | translate }}</mat-label>
                      <mat-select (selectionChange)="getVendorCats($event.value)" [(value)]="getBlockFields(blockId).data.vendorProject">
                        <mat-option *ngFor="let vendorProject of this.vendor.vendorsList" [value]="vendorProject.id">
                          {{ vendorProject.id }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  
                  <li
                    *ngIf="getBlockFields(blockId).data.vendorProject && getBlockFields(blockId).data?.slides[slides.index]?.link == 'vendorCat' && builderService.standalone">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ getBlockFields(blockId).data.vendorProject }} {{ 'Categories' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('vendorCat', blockId, $event,  'select', slides.index, 'menuItems')"
                        [(value)]="getBlockFields(blockId).data.vendorCat">
                        <mat-option *ngFor="let vendorCat of this.standaloneCategoriesService.storedVendorCategories"
                          [value]="vendorCat.id">
                          {{ vendorCat.name }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>

                  <!-- <li *ngIf="getBlockFields(blockId).data?.slides[slides.index].link == 'posts'">
                      <mat-label>{{'Post-Type' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('post_type', blockId, $event, 'multilevelSelect', slides.index, 'slides')"
                        value="{{getBlockFields(blockId).data?.slides[slides.index].post_type}}">
                        <mat-option *ngFor="let postType of postTypes" [value]="postType">
                          {{postType}}
                        </mat-option>
                      </mat-select>
                    </li> -->
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'posts'">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'WP Posts' | translate }}</mat-label>
                      <mat-select (selectionChange)="queryChange('post', blockId, $event, 'multilevelSelect', slides.index, 'slides')" [(value)]="getBlockFields(blockId).data?.slides[slides.index].post">
                        <mat-option *ngFor="let post of storedPosts" [value]="post.ID">
                          {{ post.post_title }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </li>
                  <!-- 
                    <li *ngIf="getBlockFields(blockId).data?.slides[slides.index].link == 'stacksProducts'">
                      <mat-form-field appearance="outline">
                        <mat-label>{{'Product' | translate }}</mat-label>
                        <mat-select (selectionChange)="queryChange('stacksProduct', blockId, $event, 'multilevelSelect', slides.index, 'slides')" 
                          [(value)]="getBlockFields(blockId).data?.slides[slides.index].post" >
                            <mat-option *ngFor="let post of storedPosts"
                              [value]="post.ID">
                              {{post.post_title}} 
                            </mat-option>
                          </mat-select>
                      </mat-form-field>
                    </li>

                    <li *ngIf="getBlockFields(blockId).data?.slides[slides.index].link == 'stacksCategories'">
                      <mat-form-field appearance="outline">
                        <mat-label>{{ 'Category' | translate }}</mat-label>
                        <mat-select (selectionChange)="queryChange('stacksCategory', blockId, $event, 'multilevelSelect', slides.index, 'slides')" 
                          [(value)]="getBlockFields(blockId).data?.slides[slides.index].post" >
                            <mat-option *ngFor="let post of storedPosts"
                              [value]="post.ID">
                              {{post.post_title}} 
                            </mat-option>
                          </mat-select>
                      </mat-form-field>
                    </li> -->

              <!-- in App Browser Options to open -->
              <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'externalURL'" class="externalContent">
              <label class="externalOptions">
                  <input
                    type="radio"
                    name="browseOption-{{getBlockFields(blockId).data?.slides[slides.index].index}}"
                    value="browser"
                    [checked]="!getBlockFields(blockId).data?.slides[slides.index].browseOption ||  getBlockFields(blockId).data?.slides[slides.index]?.browseOption === 'browser'"
                    (change)="queryChange('browseOption', blockId, $event, 'multilevelText',slides.index, 'slides')"
                  />
                  {{ 'Browser' | translate}}
                </label>
                  <label class="externalOptions">
                    <input
                      type="radio"
                      name="browseOption-{{getBlockFields(blockId).data?.slides[slides.index].index}}"
                      value="inApp"
                      [checked]="getBlockFields(blockId).data?.slides[slides.index]?.browseOption === 'inApp'"
                      (change)="queryChange('browseOption', blockId, $event, 'multilevelText',slides.index, 'slides')"
                    />
                    {{'In-app Browse' | translate}}
                  </label>
                </li>
                  <li *ngIf="getBlockFields(blockId).data?.slides[slides.index]?.link == 'externalURL'">
                    <mat-form-field appearance="outline">
                      <mat-label>{{ 'External URL' | translate }}</mat-label>
                      <input matInput value="{{ getBlockFields(blockId).data?.slides[slides.index].externalURL }}" (keyup)="queryChange('externalURL', blockId, $event, 'multilevelText', slides.index, 'slides')" />
                    </mat-form-field>
                  </li>
                </ul>
              </div>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </li>

      <li>
        <button class="addItem" (click)="addSliderItem(blockId)">{{ 'Add Item' | translate }}</button>
      </li>
    </ul>
  </div>
  <div class="styleFields" *ngIf="checkStyle()">
    <h4 class="listTitle">{{ 'Margins' | translate }}</h4>
    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Margin Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-top']?.slice(0, -2) }}" (change)="styleChange('margin-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-right']?.slice(0, -2) }}" (change)="styleChange('margin-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-bottom']?.slice(0, -2) }}" (change)="styleChange('margin-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Margin Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="-100" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['margin-left']?.slice(0, -2) }}" (change)="styleChange('margin-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
    <mat-label>{{ 'Paddings' | translate }}</mat-label>

    <mat-divider></mat-divider>
    <ul>
      <li>
        <mat-label>{{ 'Padding Top' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['padding-top']?.slice(0, -2) }}" (change)="styleChange('padding-top', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Right' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['padding-right']?.slice(0, -2) }}" (change)="styleChange('padding-right', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Bottom' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['padding-bottom']?.slice(0, -2) }}" (change)="styleChange('padding-bottom', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
      <li>
        <mat-label>{{ 'Padding Left' | translate }}</mat-label>
        <mat-slider showTickMarks discrete max="100" min="1" step="1" thumbLabel="true">
          <input matSliderThumb ngModel="{{ getBlockFields(blockId).style['padding-left']?.slice(0, -2) }}" (change)="styleChange('padding-left', blockId, $event, 'slider')" />
        </mat-slider>
      </li>
    </ul>
  </div>
</section>
